'use client'

import { useLayoutSelector } from '@/hooks/useLayoutSelector'
import { ReactNode } from 'react'

interface ClientLayoutSelectorProps {
  children: ReactNode
}

export default function ClientLayoutSelector({ children }: ClientLayoutSelectorProps) {
  const LayoutComponent = useLayoutSelector()
  return <LayoutComponent>{children}</LayoutComponent>
}
